import { Type, Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TextField,
  BooleanField,
  SlugField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Task Type Schema - Configurable task types
 *
 * Defines different types of tasks (Sales Call, Meeting, Document Review, etc.)
 * Each type can have its own workflow of statuses.
 */

// Complete schema (with system fields)
const TaskTypeSchema = Type.Object({
  ...SystemFields, // id, uuid, created_at, updated_at

  name: StringField({
    title: 'Тип задачи',
    minLength: 1,
    maxLength: 100,
    description: 'Название типа задачи (Звонок, Встреча, Дополнительный контакт, etc.)',
  }),

  slug: SlugField({
    title: 'Slug',
    description: 'Уникальный постоянный идентификатор (SALES_CALL, MEETING, etc.)',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    maxLength: 500,
    description: 'Описание этого типа задачи',
  }),

  is_active: BooleanField({
    title: 'Активный',
    default: true,
    description: 'Доступен ли этот тип задачи для использования',
  }),
});

// TypeScript types
export type TaskType = Static<typeof TaskTypeSchema>;

// ✨ CLEAN: Schema definition following our established pattern
export default defineSchema({
  moduleName,
  tableName: 'task_types', // System will prefix with 'tasks_'
  schema: TaskTypeSchema,
  additionalIndexes: [
    'name', // Fast lookup by name
    'slug', // Fast lookup by slug (unique)
    'is_active', // Filter active types
  ],
  foreignKeys: [], // No foreign keys - this is a reference table
  dependencies: [], // No dependencies
});
